<template>
	<div class="vehicleHome" :style="{height:height+'px'}">
		<!-- <div id="map"></div> -->
		<baidu-map :center="{lng:118.82926267730716, lat: 31.876323009327903}" :zoom="18" :scroll-wheel-zoom="true"
			style="width: auto; height: 100%;">
			<!-- //是否需要全景 -->
			<!-- <bm-panorama></bm-panorama> -->
			<!-- //地图类型 -->
			<!-- <bm-map-type :map-types="['BMAP_NORMAL_MAP', 'BMAP_HYBRID_MAP']" anchor="BMAP_ANCHOR_TOP_LEFT"></bm-map-type> -->
			<bm-marker :position="markerPo"></bm-marker>
			<bml-heatmap :data="points" :max="maxValue" :radius="20" :min='minValue' :gradient="heat"></bml-heatmap>
		</baidu-map>
		<div class="vehicleHome_top">
			<img :src="imgUrl" class="vehicleHome_top_img" />
			<div class="vehicleHome_top_left">
				<div class="vehicleHome_top_time">{{nowTime}}</div>
				<div class="vehicleHome_top_day">
					<div>{{nowWeek}}</div>
					<div>{{nowDay}}</div>
				</div>
				<img src="../assets/image/天气.png" />
				<div class="screen_box1">
				<el-select v-model="deviceType" placeholder="请选择" @change="choiceType2">
					<el-option v-for="item in deviceTypeList" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
				</div>
			</div>
			<img src="../assets/image/vehicleHomeTopBtn.png" class="vehicleHome_top_right" @click="signOut" />
			<div class="screen_box2">
					<div class="screen_title">选择参数：</div>
				<el-select v-model="value" placeholder="请选择" @change="choiceType" v-loading="loading">
					<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
			</div>
		</div>
		<div class="vehicleHome_list_box">
			<div class="vehicleHome_list" v-for="(item, index) in vehicleHomeList">
				<router-link :to="{ name: item.routeName }"><img :src="item.url" />
					{{item.name}}
				</router-link>
			</div>
		</div>
		<div class="vehicleHome_centre" :style="{width:width+'px'}">
			<div class="vehicleHome_left" ref="leftWidth">
				<div :style="{transform:'translateX(' +(icontranslateX1+20) + 'px)'}" class="indent_box">
					<div class="monitor_title">
						气象监测
					</div>
					<div class="monitor_box" style="border-bottom: 1px solid #CCCCCC;">
						<div class="monitor_left">
							<div class="monitor">
								<img src="../assets/image/monitor1.png">
								<div class="monitor_text">
									<div>
										温度
									</div>
									<div style="color: #666666;">
										<span
											style="font-weight: bold;font-size: 14px;padding-right: 3px;">{{environment.temperature}}</span>
									</div>
								</div>
							</div>
							<div class="monitor">
								<img src="../assets/image/monitor2.png">
								<div class="monitor_text">
									<div>
										湿度
									</div>
									<div style="color: #666666;">
										<span
											style="font-weight: bold;font-size: 14px;padding-right: 3px;">{{environment.humidity}}</span>
									</div>
								</div>
							</div>
							<div class="monitor">
								<img src="../assets/image/monitor3.png">
								<div class="monitor_text">
									<div>
										大气压强
									</div>
									<div style="color: #666666;">
										<span
											style="font-weight: bold;font-size: 14px;padding-right: 3px;">{{environment.atmosPressure}}</span>
									</div>
								</div>
							</div>
							<div class="monitor">
								<img src="../assets/image/monitor4.png">
								<div class="monitor_text">
									<div>
										光照强度
									</div>
									<div style="color: #666666;">
										<span
											style="font-weight: bold;font-size: 14px;padding-right: 3px;">{{environment.lightIntensity}}</span>
									</div>
								</div>
							</div>
						</div>
						<div class="monitor_right">
							<div class="monitor">
								<img src="../assets/image/monitor5.png">
								<div class="monitor_text">
									<div>
										风速
									</div>
									<div style="color: #666666;">
										<span
											style="font-weight: bold;font-size: 14px;padding-right: 3px;">{{environment.windSpeed}}</span>
									</div>
								</div>
							</div>
							<div class="monitor">
								<img src="../assets/image/monitor6.png">
								<div class="monitor_text">
									<div>
										风向
									</div>
									<div style="color: #666666;">
										<span
											style="font-weight: bold;font-size: 14px;padding-right: 3px;">{{environment.windDirection}}</span>
									</div>
								</div>
							</div>
							<div class="monitor">
								<img src="../assets/image/monitor7.png">
								<div class="monitor_text">
									<div>
										雨量
									</div>
									<div style="color: #666666;">
										<span
											style="font-weight: bold;font-size: 14px;padding-right: 3px;">{{environment.rainfall}}</span>
									</div>
								</div>
							</div>
							<div class="monitor">
								<img src="../assets/image/monitor8.png">
								<div class="monitor_text">
									<div>
										倾倒状态
									</div>
									<div style="color: #666666;">
										<span
											style="font-weight: bold;font-size: 14px;padding-right: 3px;">{{environment.dumpState}}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="monitor_title">
						气体监测
					</div>
					<div class="monitor_box" style="border-bottom: 1px solid #CCCCCC;">
						<div class="monitor_left">
							<div class="monitor">
								<img src="../assets/image/monitor9.png">
								<div class="monitor_text">
									<div>
										PM2.5
									</div>
									<div style="color: #666666;">
										<span
											style="font-weight: bold;font-size: 14px;padding-right: 3px;">{{gas.pm2d5}}</span>
									</div>
								</div>
							</div>
							<div class="monitor">
								<img src="../assets/image/monitor10.png">
								<div class="monitor_text">
									<div>
										PM10
									</div>
									<div style="color: #666666;">
										<span
											style="font-weight: bold;font-size: 14px;padding-right: 3px;">{{gas.pm10}}</span>
									</div>
								</div>
							</div>
							<div class="monitor">
								<img src="../assets/image/monitor11.png">
								<div class="monitor_text">
									<div>
										臭氧
									</div>
									<div style="color: #666666;">
										<span
											style="font-weight: bold;font-size: 14px;padding-right: 3px;">{{gas.ozone}}</span>
									</div>
								</div>
							</div>
						</div>
						<div class="monitor_right">
							<div class="monitor">
								<img src="../assets/image/monitor12.png">
								<div class="monitor_text">
									<div>
										一氧化碳
									</div>
									<div style="color: #666666;">
										<span
											style="font-weight: bold;font-size: 14px;padding-right: 3px;">{{gas.co}}</span>
									</div>
								</div>
							</div>
							<div class="monitor">
								<img src="../assets/image/monitor13.png">
								<div class="monitor_text">
									<div>
										二氧化硫
									</div>
									<div style="color: #666666;">
										<span
											style="font-weight: bold;font-size: 14px;padding-right: 3px;">{{gas.so2}}</span>
									</div>
								</div>
							</div>
							<div class="monitor">
								<img src="../assets/image/monitor14.png">
								<div class="monitor_text">
									<div>
										二氧化氮
									</div>
									<div style="color: #666666;">
										<span
											style="font-weight: bold;font-size: 14px;padding-right: 3px;">{{gas.no2}}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="monitor_title">
						水质监测
					</div>
					<div class="monitor_box">
						<div class="monitor_left">
							<div class="monitor">
								<img src="../assets/image/monitor9.png">
								<div class="monitor_text">
									<div>
										溶氧
									</div>
									<div style="color: #666666;">
										<span
											style="font-weight: bold;font-size: 14px;padding-right: 3px;">{{water.dissolvedOxygen}}</span>
									</div>
								</div>
							</div>
							<div class="monitor">
								<img src="../assets/image/monitor10.png">
								<div class="monitor_text">
									<div>
										温度
									</div>
									<div style="color: #666666;">
										<span
											style="font-weight: bold;font-size: 14px;padding-right: 3px;">{{water.dissolvedTemperature}}</span>
									</div>
								</div>
							</div>
						</div>
						<div class="monitor_right">
							<div class="monitor">
								<img src="../assets/image/monitor12.png">
								<div class="monitor_text">
									<div>
										电导率
									</div>
									<div style="color: #666666;">
										<span
											style="font-weight: bold;font-size: 14px;padding-right: 3px;">{{water.elecConductivity}}</span>
									</div>
								</div>
							</div>
							<div class="monitor">
								<img src="../assets/image/monitor13.png">
								<div class="monitor_text">
									<div>
										电量
									</div>
									<div style="color: #666666;">
										<span
											style="font-weight: bold;font-size: 14px;padding-right: 3px;">{{water.electricity}}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div @click="click1" :style="{transform:'translateX(' +(icontranslateX1+20) + 'px)'}"
					class="indent_btn">
					<img src="../assets/image/CaretLeft.png" v-if="icontranslateX1==0" />
					<img src="../assets/image/CaretRight.png" v-else />
				</div>
			</div>
			<div class="vehicleHome_right" ref="rightWidth">
				<div @click="click2" :style="{transform:'translateX(' +(icontranslateX2-25) + 'px)'}"
					class="indent_btn">
					<img src="../assets/image/CaretRight.png" v-if="icontranslateX2==0" />
					<img src="../assets/image/CaretLeft.png" v-else />
				</div>
				<div class="vehicle_box" :style="{transform:'translateX(' +(icontranslateX2-25) + 'px)'}">
					<div class="vehicle_btn" @click="simulation">灾情模拟</div>
					<div class="vehicle_title">
						车辆信息
					</div>
					<div class="vehicle_text">
						<div>车辆编号：{{car.number}}</div>
						<div>任务状态：{{car.taskState==0?'空闲':'执行中'}}</div>
						<div>车速：{{parseFloat(car.speed).toFixed(2)}}km/h</div>
						<div>海拔：{{parseFloat(car.altitude).toFixed(2)}}米</div>
						<div>
							车头朝向：{{parseFloat(car.azimuth)<1?'东':1<=parseFloat(car.azimuth)<=89?'东北':parseFloat(car.azimuth)==90?'北':91<=parseFloat(car.azimuth)<=179?'西北':parseFloat(car.azimuth)==180?'西':181<=parseFloat(car.azimuth)<=269?'西南':parseFloat(car.azimuth)==270?'南':'东南'}}
						</div>
						<div>纬度：{{car.latitude}}°</div>
						<div>经度：{{car.longitude}}°</div>
						<div>电流：{{parseFloat(battery.ammeter).toFixed(2)}}A</div>
						<div>充电状态：{{battery.chargingFlag==0?'未充电':'充电中'}}</div>
						<div>续航里程：{{parseFloat(battery.endurance).toFixed(2)}}km</div>
						<div>累计里程：{{parseFloat(battery.odometer).toFixed(2)}}km</div>
						<div>剩余电量：{{battery.residualFuel}}%</div>
						<div>电池温度：{{battery.temperature}}℃</div>
						<div>电池电压：{{parseFloat(battery.voltage).toFixed(2)}}V</div>
					</div>
				</div>
			</div>
		</div>
		<div class="vehicleHome_bottom" v-show="show">
			<div class="vehicle_box2">
				<div class="vehicle_title">
					实时监控(前面)
				</div>
				<iframe src="http://47.96.7.199:10000/play.html?serial=34020000001320000001&code=34020000001320000001&aspect=fullscreen" width="250" height="150" allowfullscreen allow="autoplay; fullscreen; microphone;"></iframe>
			</div>
			<div class="vehicle_box2" style="width: 850px;">
				<div class="vehicle_title">
					巡检视频(前面)
				</div>
				<video id="videoPlayer2" class="videoBox" muted></video>
			</div>
			<div class="vehicle_box2">
				<div class="vehicle_title">
					巡检视频(后面)
				</div>
				<video id="videoPlayer3" class="videoBox" muted style="object-fit: fill;"></video>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		BmlHeatmap
	} from 'vue-baidu-map'
	import videojs from "video.js";
	export default {
		name: "rtmpPlay",
		components: { //注册
			BmlHeatmap
		},
		data() {
			return {
				height: `${document.documentElement.clientHeight}`,
				width: `${document.documentElement.clientWidth}`,
				imgUrl: '',
				vehicleHomeList: [{
						name: '平台首页',
						url: require('../assets/image/vehicleHomeList1.png'),
						routeName: 'VehicleHome'
					},
					{
						name: '车辆管理',
						url: require('../assets/image/vehicleHomeList2.png'),
						routeName: 'Navigation'
					},
					{
						name: '气象监测',
						url: require('../assets/image/vehicleHomeList3.png'),
						routeName: 'Environment'
					},
					{
						name: '气体监测',
						url: require('../assets/image/vehicleHomeList4.png'),
						routeName: 'Gas'
					},
					{
						name: '水质监测',
						url: require('../assets/image/vehicleHomeList7.png'),
						routeName: 'WaterQuality'
					},
					{
						name: '视频监控',
						url: require('../assets/image/vehicleHomeList5.png'),
						routeName: 'Video'
					},
					{
						name: '平台告警',
						url: require('../assets/image/vehicleHomeList6.png'),
						routeName: 'Platformalarm'
					},
					{
						name: '历史热图',
						url: require('../assets/image/vehicleHomeList8.png'),
						routeName: 'HistoryMap'
					},
				],
				icontranslateX1: 0, //沿x轴位移px
				icontranslateX2: 0, //沿x轴位移px
				timer: '', //定义的计数器
				nowTime: '', //当前时间
				nowDay: '', //当前日期
				nowWeek: '', //当前星期
				websock: null, //websock
				environment: { //气象监测
					atmosPressure: 0, //大气压强
					dumpState: 0, //倾倒状态
					humidity: 0, //湿度
					lightIntensity: 0, //光照强度
					rainfall: 0, //雨量
					temperature: 0, //温度
					windDirection: 0, //风向
					windSpeed: 0, //风速
				},
				water:{
					dissolvedOxygen:0,
					dissolvedTemperature:0,
					elecConductivity:0,
					electricity:0,
				},
				gas: { //气体监测
					co: 0, //一氧化碳
					no2: 0, //二氧化氮
					ozone: 0, //臭氧
					pm2d5: 0, //PM2.5
					pm10: 0, //PM10
					so2: 0, //二氧化硫
				},
				car: { //车辆信息
					altitude: '东', //方向
					azimuth: 0, //车头朝向
					driveMode: '', //驾驶模式
					latitude: 0, //纬度
					longitude: 0, //经度
					number: 0, //车辆编号
					speed: 0, //速度
					taskState: 0, //任务状态
				},
				battery: { //电池信息
					ammeter: 0, //电流
					chargingFlag: 0, //是否正在充电
					endurance: 0, //续航里程
					odometer: 0, //累计里程
					residualFuel: 0, //剩余电量
					temperature: 0, //电池温度
					voltage: 0, //电池电压
				},
				show: false,
				markerPo: {},
				heat: {
					'0.3': 'rgb(0, 255, 0)',
					'0.6': 'rgb(255, 255, 0)',
					'0.9': 'rgb(225, 75, 0)'
				},
				points: [],
				maxValue:10,
				minValue:1,
				options: [{
					value: 1,
					label: '空气温度'
				},{
					value: 2,
					label: '空气湿度'
				},{
					value: 3,
					label: '大气压强'
				},{
					value: 4,
					label: '光照强度'
				},{
					value: 5,
					label: '风向'
				},{
					value: 6,
					label: '风速'
				},{
					value: 7,
					label: '降雨量'
				},{
					value: 9,
					label: 'PM 2.5'
				}, {
					value: 10,
					label: 'PM 10'
				}, {
					value: 14,
					label: '臭氧'
				}, {
					value: 15,
					label: '一氧化碳'
				}, {
					value: 16,
					label: '二氧化硫'
				}, {
					value: 17,
					label: '二氧化氮'
				}],
				deviceTypeList:[{
					value: 1,
					label: '车载'
				}, {
					value: 2,
					label: '气象站'
				}],
				deviceType:1,
				value: 1,
				endDate: '',
				startDate: '',
				loading: false,
				control:true
			};

		},
		mounted() {
			this.getData()
			if (this.width < 1400) {
				this.imgUrl = require('../assets/image/vehicleHomeTop2.png')
			} else {
				this.imgUrl = require('../assets/image/vehicleHomeTop.png')
			}
			// this.map(118.829649,31.878419)
			const nowDate = new Date();
			const date = {
				year: nowDate.getFullYear(),
				month: nowDate.getMonth() + 1,
				date: nowDate.getDate(),
			};
			const newmonth = date.month > 9 ? date.month : "0" + date.month;
			const day = date.date > 9 ? date.date : "0" + date.date;
			this.endDate = date.year + "-" + newmonth + "-" + day + ' 23:59';
			this.startDate = date.year + "-" + newmonth + "-" + day + ' 00:00';
			console.log(this.endDate )
			this.getR(1)
			this.getPoints()
			//时间转换
			this.timer = setInterval(() => {
				let date = new Date();
				let year = date.getFullYear();
				let wk = date.getDay()
				/* 在日期格式中，月份是从0开始的，因此要加0
				 * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
				 * */
				let month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
				let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
				let hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
				let minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
				let seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
				let weeks = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
				let week = weeks[wk]
				// 拼接
				this.nowTime = hours + ":" + minutes + ":" + seconds;
				this.nowDay = year + "-" + month + "-" + day;
				this.nowWeek = week
				// return year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
			}, 1000)
		},
		destroyed() {
			this.$router.go(0)
		},
		methods: {
			getVideo(liveUrl, frontPatrolUrl, backPatrolUrl) {
				let options1 = {
					autoplay: true, // 设置自动播放
					controls: true, // 显示播放的控件
					language: "zh-CN",
					notSupportedMessage: "此视频暂无法播放，请稍后再试",
					sources: [
						//如果需要切换视频源，src需要动态设置
						{
							src: liveUrl,
							type: "application/x-mpegURL", // 告诉videojs,这是一个m3u8流
						},
					],
				};
				let options2 = {
					autoplay: true, // 设置自动播放
					controls: true, // 显示播放的控件
					language: "zh-CN",
					notSupportedMessage: "此视频暂无法播放，请稍后再试",
					sources: [
						//如果需要切换视频源，src需要动态设置
						{
							src: frontPatrolUrl,
							type: "application/x-mpegURL", // 告诉videojs,这是一个m3u8流
						},
					],
				};
				let options3 = {
					autoplay: true, // 设置自动播放
					controls: true, // 显示播放的控件
					notSupportedMessage: "此视频暂无法播放，请稍后再试",
					sources: [
						//如果需要切换视频源，src需要动态设置
						{
							src: backPatrolUrl,
							type: "application/x-mpegURL", // 告诉videojs,这是一个m3u8流
						},
					],
				};
				// videojs的第一个参数表示的是，文档中video的id
				// console.log('zhix', frontPatrolUrl)
				// videojs("videoPlayer1", options1, function onPlayerReady() {});
				videojs("videoPlayer2", options2, function onPlayerReady() {});
				videojs("videoPlayer3", options3, function onPlayerReady() {});
			},
			async getData() {
				let result = await this.request.post("/v1.0/car/getHomeData", {
					'deviceType':this.deviceType
				});
				console.log(result.data)
				this.$nextTick(() => {
					this.getVideo(result.data.video.liveUrl, result.data.video.frontPatrolUrl,
						result.data.video.backPatrolUrl);
				});
				this.show = true
			},
			async getR(type) {
				let result = await this.request.post("/v1.0/car/getHeatData", {
					'type': type, 
					'startDate': this.startDate,
					'endDate': this.endDate,
					'deviceType':this.deviceType
				});
				this.points = result.data.dataList.map((item) => {
					return {
						'lng': parseFloat(item.lng) + 0.012,
						'lat': parseFloat(item.lat) + 0.004,
						'count': parseFloat(item.count)
					}
				})
				this.maxValue = result.data.maxValue
				this.minValue = result.data.minValue
				this.loading = false
				this.$notify({
					title: '执行成功',
					message: '热力图渲染成功',
					type: 'success'
				});
			},
			async getPoints() {
				let result = await this.request.post("/v1.0/car/getHomeData", {
					'deviceType':this.deviceType
				});
				this.markerPo = {
					'lng': parseFloat(result.data.car.longitude) + 0.012,
					'lat': parseFloat(result.data.car.latitude) + 0.004
				}
				this.environment = result.data.environment
				this.gas = result.data.gas
				this.water = result.data.water
				this.car = result.data.car
				this.battery = result.data.battery
				if(result.data&&this.control){
					this.getPoints()
				}
			},
			async simulation() {
				let result = await this.request.post("/v1.0/car/disasterSimulate", {});
				console.log(result.code)
				if (result.code == 0) {
					this.$notify({
						title: '执行成功',
						message: '执行成功',
						type: 'success'
					});
				}
			},
			map(longitude, latitude) {
				console.log('longitude', longitude, 'latitude', latitude)
				var map = new BMap.Map("map"); // 创建Map实例
				// 百度地图API功能
				map.centerAndZoom(new BMap.Point(118.82926267730716, 31.877123009327903), 18); // 初始化地图,设置中心点坐标和地图级别
				map.setCurrentCity("南京"); // 设置地图显示的城市 此项是必须设置的
				map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
				var marker = new BMap.Marker(new BMap.Point(longitude, latitude));
				map.addOverlay(marker);
			},
			signOut() {
				this.$router.push({
					name: 'Login'
				})
			},
			click1: function() { //图标点击事件
				if (this.icontranslateX1 == 0) {
					this.icontranslateX1 = -this.$refs.leftWidth.clientWidth
				} else {
					this.icontranslateX1 = 0
				}
			},
			click2: function() { //图标点击事件
				if (this.icontranslateX2 == 0) {
					this.icontranslateX2 = this.$refs.rightWidth.clientWidth
				} else {
					this.icontranslateX2 = 0
				}
			},
			choiceType(e){
				console.log(e)
				this.loading = true
				this.getR(e)
			},
			choiceType2(e){
				this.$notify({
					title: '切换成功',
					message: '切换成功',
					type: 'success'
				});
			}
		},
		destroyed() {
		    console.log('==离开页面==')
			this.control = false
			clearInterval(this.timer)
		 },
	};
</script>

<style>
	body {
		overflow-x: hidden;
	}

	#map {
		float: left;
		width: 100%;
		height: 100%;
	}

	.BMap_cpyCtrl {
		display: none;
	}

	.anchorBL {
		display: none;
	}

	.vehicleHome {
		/* background: url(../assets/vehicleHomeBG.png) no-repeat; */
		background-size: cover;
		-webkit-background-size: cover;
		-o-background-size: cover;
		background-position: center 0;
	}

	.vehicleHome_top {
		height: 8%;
		width: 100%;
		top: 0;
		position: fixed;
		/* background: url(../assets/image/vehicleHomeTop.png) no-repeat;
		background-size: cover;
		-webkit-background-size: cover;
		-o-background-size: cover;
		background-position: center 0;
		position: relative; */
	}

	.vehicleHome_top_img {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		;
	}

	.vehicleHome_top_left {
		position: absolute;
		left: 7%;
		height: 40%;
		top: 30%;
		width: 530px;
		display: flex;
	}

	.vehicleHome_top_time {
		font-size: 24px;
		color: #fff;
		padding-right: 18px;
	}

	.vehicleHome_top_day {
		font-size: 12px;
		color: #fff;
		text-align: right;
	}

	.vehicleHome_top_left img {
		margin-left: 18px;
		width: 30px;
		height: 30px;
	}

	.vehicleHome_top_right {
		position: absolute;
		right: 7%;
		height: 70%;
		top: 17%;
		cursor: pointer;
		z-index: 999;
	}

	.vehicleHome_list_box {
		display: flex;
		justify-content: space-around;
		padding: 16px 100px;
		position: absolute;
		top: 8%;
		width: 100%;
	}

	@media screen and (max-width: 1500px) {
		.vehicleHome_list_box {
			padding: 16px 50px;
		}

	}

	@media screen and (max-width: 1350px) {
		.vehicleHome_list_box {
			padding: 16px 0;
		}

	}

	.vehicleHome_list {
		border-radius: 14px;
		background-color: #394177;
		line-height: 35px;
	}

	.vehicleHome_list img {
		width: 35px;
		height: 35px;
		margin-right: 17px;
		float: left;
	}

	.vehicleHome_list a {
		padding: 10px 18px 10px 14px;
		color: #FFFFFF;
		font-size: 14px;
	}

	.vehicleHome_centre {
		display: flex;
		justify-content: space-between;
		width: 100%;
		position: absolute;
		top: 19%;
	}

	.vehicleHome_bottom {
		display: flex;
		position: absolute;
		left: 370px;
		bottom: 20px;
		background-color: rgba(255, 255, 255, 0.8);
		border-radius: 12px;
	}

	.vehicle_box2 {
		width: 300px;
		padding: 20px 26px;
	}

	.vehicleHome_left {
		margin-left: 5px;
		display: flex;
		position: absolute;
		left: 0;
		top: 0;
	}

	.vehicleHome_left .indent_box {
		width: 318px;
		transition: transform 2s;
		padding: 0 12px 10px 12px;
		border-radius: 12px;
		background-color: rgba(255, 255, 255, 0.8);
	}

	.monitor_title {
		text-align: center;
		line-height: 50px;
		color: #666666;
		font-size: 16px;

	}

	.monitor_box {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		width: 100%;
		padding: 0 5px;
	}

	.monitor_left {
		width: 57%;
	}

	.monitor_right {
		width: 43%;
	}

	.monitor {
		margin-bottom: 20px;
	}

	.monitor img {
		width: 45px;
		height: 45px;
		float: left;
		margin-right: 10px;
	}

	.monitor .monitor_text {
		font-size: 14px;
		color: #999999;
	}

	.vehicle_box {
		width: 310px;
		transition: transform 2s;
		padding: 20px 26px;
		border-radius: 12px;
		background-color: rgba(255, 255, 255, 0.8);
	}

	.vehicle_btn {
		position: absolute;
		right: 30px;
		top: 15px;
		width: 80px;
		line-height: 30px;
		text-align: center;
		background-color: #5f6cbd;
		border-radius: 5px;
		font-size: 12px;
		color: #fff;
	}

	.vehicle_title {
		font-size: 16px;
		color: #666666;
		padding-bottom: 16px;
	}

	.videoBox {
		position: relative;
		width: 100%;
		height: 150px;
	}

	.vjs-has-started .vjs-control-bar,
	.vjs-audio-only-mode .vjs-control-bar {
		display: none;
	}

	.vjs-error .vjs-error-display .vjs-modal-dialog-content {
		font-size: 16px;
	}

	.vjs-control-text {
		display: none;
	}

	video {
		width: 100%;
		height: 100%;
	}

	.vehicle_text {
		color: #666666;
		font-size: 14px;
		line-height: 24px;
		padding-bottom: 20px;
	}

	.vehicleHome_left .indent_btn {
		margin-top: 20px;
		width: 30px;
		text-align: center;
		background-color: rgba(180, 165, 255, 0.8);
		;
		height: 30px;
		border-radius: 0px 20px 20px 0px;
		/* box-shadow: 5px 5px 5px #bcbcbc; */
		position: relative;
		transition: transform 2s;
	}

	.vehicleHome_left .indent_btn img {
		position: absolute;
		top: 50%;
		line-height: 50px;
		margin-top: -10px;
		right: 7px;
		width: 20px;
	}

	.vehicleHome_right {
		position: absolute;
		right: 0;
		top: 0;
		display: flex;
	}

	.vehicleHome_right img {
		width: 95%;
		transition: transform 2s;
	}

	.vehicleHome_right .indent_btn {
		margin-top: 20px;
		width: 30px;
		text-align: center;
		background-color: rgba(180, 165, 255, 0.8);
		;
		height: 30px;
		border-radius: 20px 0px 0px 20px;
		/* box-shadow: 5px 5px 5px #bcbcbc; */
		position: relative;
		transition: transform 2s;
	}

	.vehicleHome_right .indent_btn img {
		position: absolute;
		top: 50%;
		line-height: 50px;
		margin-top: -10px;
		right: 4px;
		width: 20px;
	}
	.screen_box1{
		margin-top: -5px;
		padding-left: 30px;
		display: flex;
		width:150px;
		line-height: 40px;
		z-index: 999;
	}
	.screen_box2{
		padding-top: 15px;
		display: flex;
		width:15%;
		position:absolute;
		right: 250px;
		line-height: 40px;
		z-index: 999;
	}
	
	.screen_title {
		font-size: 12px;
		color: #fff;
	}
</style>
